<template>
    <b-container>
    <b-table 
         striped hover 
         :items="items" 
         :fields="fields"
         :current-page="currentPage"
         :per-page="perPage"
        
         :sort-by.sync="sortBy"
         :sort-desc.sync="sortDesc"
         :sort-direction="sortDirection"
         
        >
        <template v-slot:cell(acciones)="row">
            <b-button size="sm"  @click="activar(row.item, row.index, $event.target)">
                Activar
            </b-button>
        </template>


    </b-table>
    
     <b-col cols="6">
            <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
        </b-col>
    </b-container>
</template>

<script>
 import {mapActions,mapMutations} from 'vuex'
 import userForm from '@/components/admin/userForm'
  import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    export default {
        components:{
            userForm
        },  
        mixins : [validateMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 5,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                item:[],
                
            }
        },
        methods:{
            ...mapActions({
                _activar: 'admin/activar',
                
            }),
            ...mapMutations({
                _setUser: 'admin/setUser'
            }),
            activar(item, index, button){
                this._activar(item).then(() => {
                   //  
                })
            },
            
           
           
        }
        
    }
</script>

<style lang="scss" scoped>

</style>